module.exports = __webpack_public_path__ + "img/4_x4.ae18709b.png";